import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { isAndroid } from 'react-device-detect';

import { forms as Forms } from '@breezeway/brzw-components';
import ModalSelect from '../modal_select';

import './mobile_native_select.scss';

class MobileNativeSelect extends PureComponent {
  constructor(props) {
    super(props);

    this.nativeSelect = React.createRef();

    this.state = {
      openModal: false,
    };

    this.focusNativeSelect = this.focusNativeSelect.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  onSelect(e) {
    if (_.has(e, 'preventDefault')) {
      e.preventDefault();
      e.stopPropagation();
    }

    const { options, onSelect } = this.props;
    const option = _.find(options, element => `${element.value}` === _.get(e, 'target.value'));
    onSelect(option);
  }

  toggleModal(e) {
    const { disabled } = this.props;
    const eventTagTarget = _.get(e, 'target.tagName');
    if (!disabled && eventTagTarget !== 'BUTTON') {
      if (isAndroid) {
        this.setState(prevState => ({
          openModal: !prevState.openModal,
        }));
      } else {
        this.focusNativeSelect();
      }
    }
  }

  focusNativeSelect() {
    _.invoke(this.nativeSelect, 'current.focus');
  }

  render() {
    const {
      disabled,
      labelText,
      onSelect,
      options,
      placeholderText,
      selectClassName,
      value,
      withClearAction,
    } = this.props;

    const optionsWithDefault = [{ value: null, label: '-' }, ...options];

    return (
      <div className="mobile-native-select__wrapper">
        <div role="presentation" onClick={this.toggleModal}>
          <Forms.Select
            className={selectClassName}
            labelText={labelText}
            onSelect={onSelect}
            options={options}
            placeholderText={placeholderText}
            searchable
            shouldOpenModal
            value={value}
            withClearAction={withClearAction}
            withNativeSelect
          />
        </div>
        {!isAndroid && (
          <select
            className="mobile-native-select__select"
            disabled={disabled}
            onChange={this.onSelect}
            ref={this.nativeSelect}
            value={value || undefined}
          >
            {_.map(optionsWithDefault, option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        )}
        {this.state.openModal && (
          <ModalSelect
            full
            onClose={this.toggleModal}
            onSelect={onSelect}
            options={options}
            order={false}
            title={labelText}
            wrapClassName="style-guide"
          />
        )}
      </div>
    );
  }
}

MobileNativeSelect.propTypes = {
  disabled: PropTypes.bool,
  labelText: PropTypes.string,
  onSelect: PropTypes.func,
  options: PropTypes.array,
  placeholderText: PropTypes.string,
  selectClassName: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  withClearAction: PropTypes.bool,
};

MobileNativeSelect.defaultProps = {
  disabled: false,
  placeholderText: 'Select',
  selectClassName: '',
  withClearAction: false,
};

export default MobileNativeSelect;
